import Vue from 'vue'
import Router from 'vue-router'

import PageLogin from '../components/pages/PageLogin'
import PageDashboard from '../components/pages/PageDashboard'
import PageSetting from '../components/pages/PageSetting'
import PageUser from '../components/pages/PageUser'

import PageAgencie from '../components/pages/PageAgencie'
import PageCertificate from '../components/pages/PageCertificate'

import PageCustomer from '../components/pages/PageCustomer'
import PageDownload from '../components/pages/PageDownload'
import PageForbidden from '../components/pages/PageForbidden'
import PageNotFound from '../components/pages/PageNotFound'

import PageProduct from '../components/pages/PageProduct'
import PageProductCategory from '../components/pages/PageProductCategory'

import PageOrderStatus from '../components/pages/PageOrderStatus'


import PageContactService from '../components/pages/PageContactService'
import PageContactQuotation from '../components/pages/PageContactQuotation'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/',
        redirect: '/dashboard',
    },
        {
            path: '/login', name: 'pageLogin', component: PageLogin,
            meta: {auth: false}
        },
        {
            path: '/dashboard', name: 'pageDashboard', component: PageDashboard,
            meta: {auth: ['admin']}
        },
        {
            path: '/order-status', name: 'pageOrderStatus', component: PageOrderStatus,
            meta: {auth: ['admin']}
        },
        {
            path: '/setting/:key?', name: 'pageSetting', component: PageSetting,
            meta: {auth: ['admin']}
        },
        {
            path: '/user', name: 'pageUser', component: PageUser,
            meta: {auth: ['admin']}
        },

        {
            path: '/agencies', name: 'pageAgencie', component: PageAgencie,
            meta: {auth: ['admin']}
        },
        {
            path: '/certificates', name: 'pageCertificate', component: PageCertificate,
            meta: {auth: ['admin']}
        },
        {
            path: '/customers', name: 'pageCustomer', component: PageCustomer,
            meta: {auth: ['admin']}
        },
        {
            path: '/downloads', name: 'pageDownload', component: PageDownload,
            meta: {auth: ['admin']}
        },
        {
            path: '/forbidden', name: 'pageForbidden', component: PageForbidden,
            meta: {auth: ['admin']}
        },

        {
            path: '/not-found', name: 'pageNotFound', component: PageNotFound,
            meta: {auth: ['admin']}
        },
        {
            path: '/products', name: 'pageProduct', component: PageProduct,
            meta: {auth: ['admin']}
        },
        {
            path: '/product-categories', name: 'pageProductCategory', component: PageProductCategory,
            meta: {auth: ['admin']}
        },

        {
            path: '/contact-services', name: 'pageContactService', component: PageContactService,
            meta: {auth: ['admin']}
        },
        {
            path: '/contact-quotations', name: 'pageContactQuotation', component: PageContactQuotation,
            meta: {auth: ['admin']}
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js